module.exports = __webpack_public_path__ + "assets/img/config-table-7407a944.png";